module.exports = __webpack_public_path__ + "img/m7.eafc43e8.svg";